export default class CountdownBlock extends HTMLDivElement {

    date = null;
    days = null;
    hours = null;
    minutes = null;
    text = null;
    lastMinute = null;

    connectedCallback() {
        this.date = new Date(this.dataset.date);
        this.days = this.querySelector(".countdown-days");
        this.hours = this.querySelector(".countdown-hours");
        this.minutes = this.querySelector(".countdown-minutes");
        this.text = this.querySelector(".countdown-text");
        this.update();
    }

    update = () => {
        const now = new Date(),
            currentMinute = now.getMinutes();

        if (currentMinute !== this.lastMinute) {

            this.lastMinute = currentMinute;

            // we don't want to handle seconds, just show exact minutes
            now.setSeconds(0, 0);

            const diff = this.getTimeDiff(this.date, now);

            if (diff.total < 0)
                return;

            let countDownText = "";

            if (diff.days === 1) {
                this.days.innerHTML = `${this.wrapChars(diff.days)} <div class="countdown-number-label">dag</div>`;
                countDownText += `${diff.days} dag`;
            }
            else {
                this.days.innerHTML = `${this.wrapChars(diff.days)} <div class="countdown-number-label">dagar</div>`;
                countDownText += `${diff.days} dagar`;
            }

            if (diff.hours === 1) {
                this.hours.innerHTML = `${this.wrapChars(diff.hours)} <div class="countdown-number-label">timme</div>`;
                countDownText += `, ${diff.hours} timme`;
            }
            else {
                this.hours.innerHTML = `${this.wrapChars(diff.hours)} <div class="countdown-number-label">timmar</div>`;
                countDownText += `, ${diff.hours} timmar`;
            }

            if (diff.minutes === 1) {
                this.minutes.innerHTML = `${this.wrapChars(diff.minutes)} <div class="countdown-number-label">minut</div>`;
                countDownText += `, ${diff.minutes} minut`;
            }
            else {
                this.minutes.innerHTML = `${this.wrapChars(diff.minutes)} <div class="countdown-number-label">minuter</div>`;
                countDownText += `, ${diff.minutes} minuter`;
            }

            this.text.innerText = countDownText;
        }

        requestAnimationFrame(this.update);
    }

    getTimeDiff(start, end) {
        const diffInMilliseconds = Math.abs(end - start);

        const totalMinutes = Math.floor(diffInMilliseconds / (1000 * 60));
        const totalHours = Math.floor(totalMinutes / 60);
        const totalDays = Math.floor(totalHours / 24);

        const days = totalDays;
        const hours = totalHours % 24;
        const minutes = totalMinutes % 60;

        return { days, hours, minutes };
    }

    wrapChars(text) {
        return `<div class="countdown-digit">${String(text).split("").join("</div><div class=\"countdown-digit\">")}</div>`;
    }

}

customElements.define("countdown-block", CountdownBlock, { extends: "div" });